import uniq from 'lodash/uniq';
import flatten from 'lodash/flatten';

import config from '../config';
import { categoryOptions } from '../filtersOptions';
import { findOptionsForSelectFilter } from './search';

export const prepareKeywords = keywords => {

  if (!keywords) return '';

  return keywords
    .trim()
    .toLowerCase()
    .replace(/\n/g, '')
    .replace(/\t/g, '')
    .replace(/[(),.?!:#$"']/g, '')
    .split(' ')
    .filter(i => !!i)
    .filter(i => i.length > 2)
    ;
};

export const getPostsKeywords = (news, content, events) => {
  const newsData = (news && news.length) ? news : [];
  const contentData = (content && content.length) ? content : [];
  const eventsData = (events && events.length) ? events : [];

  const newsTitles = newsData.map(n => n?.title);
  const newsDescriptions = newsData.map(n => n?.description);
  const newsCategories = newsData.map(n => n?.category);
  const newsCategoryNames = (newsCategories.flat() || []).map(i => {
    const item = categoryOptions.find(opt => opt.key === i);
    return item ? item.label : null;
  }).filter(i => !!i);

  const contentTitles = contentData.map(c => c?.title);
  const contentDescriptions = contentData.map(c => c?.description);
  const contentCategories = contentData.map(c => c?.category);
  const contentCategoryNames = (contentCategories.flat() || []).map(i => {
    const item = categoryOptions.find(opt => opt.key === i);
    return item ? item.label : null;
  }).filter(i => !!i);

  const eventsTitles = eventsData.map(c => c?.title);

  return uniq(flatten([
    ...newsTitles.map(i => prepareKeywords(i)),
    ...newsDescriptions.map(i => prepareKeywords(i)),
    ...newsCategoryNames?.map(i => prepareKeywords(i)),
    ...contentTitles?.map(i => prepareKeywords(i)),
    ...contentDescriptions?.map(i => prepareKeywords(i)),
    ...contentCategoryNames?.map(i => prepareKeywords(i)),
    ...eventsTitles?.map(i => prepareKeywords(i)),
  ]));
};

export const getDescriptionKeywords = (title, description, category, subcategory, differentiationFromCompetitors, offerDescription, shortDescription) => {
  const categoryOptions = findOptionsForSelectFilter('category', config.custom.filters);
  const subCategoryOptions = findOptionsForSelectFilter('subcategory', config.custom.filters);
  const selectedCategoryNames = (category || []).map(i => {
    const item = categoryOptions.find(opt => opt.key === i);
    return item ? item.label : null;
  }).filter(i => !!i);

  const selectedSubCategoryNames = (subcategory || []).map(i => {
    const item = subCategoryOptions.find(opt => opt.key === i);
    return item ? item.label : null;
  }).filter(i => !!i);

  const selectedDifferentiationFromCompetitors = differentiationFromCompetitors?.filter(i => !!i) || [];

  return uniq(flatten([
    ...prepareKeywords(title),
    ...prepareKeywords(description),
    ...prepareKeywords(offerDescription),
    ...prepareKeywords(shortDescription),
    ...selectedCategoryNames.map(i => prepareKeywords(i)),
    ...selectedSubCategoryNames.map(i => prepareKeywords(i)),
    ...selectedDifferentiationFromCompetitors.map(i => prepareKeywords(i)),
  ]));
};
